(function($){
    $.fn.multiEmail = function($options) {
        var $defaults = {
            delete: false,
            data: null,
            target: $(".list"),
            model:'@email',
            removeEle:'.remove',
            emailSend:'.send',
            ajax:{
                method:'POST',
                url:'',
                data:{},
                dataType:'json'
            },
            callback:(function(){})
        };
        var $settings = $.extend($defaults, $options);
        var $emails = [];
        var $emailRegex = new RegExp('^\\s*[\\w\\-\\+_]+(\\.[\\w\\-\\+_]+)*\\@[\\w\\-\\+_]+\\.[\\w\\-\\+_]+(\\.[\\w\\-\\+_]+)*\\s*$', 'i');
        var $splitRegex = new RegExp('[;,]', 'g');
        return {
            'delete':function(){
                $emails = [];
                $settings.target.html('');
                $(this).val('');
            },
            'selector':this.each(function () {
                var $that = $(this);
                $that.val('');
                $that.css('border', '');
                if($that.next().hasClass('error')){
                    $that.next().remove();
                }
                if ($settings.delete) {
                    if ($settings.target.length > 0) {
                        $emails = [];
                        $that.val('');
                    }
                }
                if ($settings.data) {
                    $.each($settings.data, function ($i, $v) {
                        $.ajax({
                            method: $settings.ajax.method,
                            url: $settings.ajax.url,
                            data: $.extend({}, {emails:$v}, $settings.ajax.data),
                            dataType: $settings.ajax.dataType,
                            success: function ($data) {
                                libs.expire($data);
                                var $model = $settings.model;
                                $model = $model.replace(/@email/g, $v);
                                if($data.data.users.length > 0){
                                    $model = $model.replace('@link', $data.data.users[0].profile_url);
                                    $model = $model.replace($($model).find('.not_exist:first').html(), '');
                                }else{
                                    $model = $model.replace($($model).find('.exist:first').html(), '');
                                }
                                $emails.push($v);
                                $settings.target.append($model).ready(function () {
                                    $settings.target.find($settings.emailSend).unbind().click(function () {
                                        var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                        var $index = $emails.indexOf($sendEmail);
                                        if ($index > -1) {
                                            $emails.splice($index, 1);
                                        }
                                        $(this).parents('.item:first').remove();
                                        $settings.callback($sendEmail);
                                    });
                                    $settings.target.find($settings.removeEle).unbind().click(function () {
                                        var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                        var $index = $emails.indexOf($sendEmail);
                                        if ($index > -1) {
                                            $emails.splice($index, 1);
                                        }
                                        $(this).parents('.item:first').remove();
                                    });
                                });
                            }
                        });
                    });
                }
                $that.unbind('keydown').unbind('keyup')
                    .keydown(function ($e) {
                        $that.css('border', '');
                        if($that.next().hasClass('error')){
                            $that.next().remove();
                        }
                        if ($e.keyCode === 32 || $e.keyCode === 188) {
                            var $emailInputVal = $.trim($that.val());
                            if ($emailRegex.test($emailInputVal) && $emails.indexOf($emailInputVal) == -1) {
                                $that.val('');
                                $.ajax({
                                    method: $settings.ajax.method,
                                    url: $settings.ajax.url,
                                    data: $.extend({}, {emails:$emailInputVal}, $settings.ajax.data),
                                    dataType: $settings.ajax.dataType,
                                    success: function ($data) {
                                        libs.expire($data);
                                        var $model = $settings.model;
                                        $model = $model.replace(/@email/g, $emailInputVal);
                                        if($data.data.users.length > 0){
                                            $model = $model.replace('@link', $data.data.users[0].profile_url);
                                            $model = $model.replace($($model).find('.not_exist:first').html(), '');
                                        }else{
                                            $model = $model.replace($($model).find('.exist:first').html(), '');
                                        }
                                        $emails.push($emailInputVal);
                                        $settings.target.append($model).ready(function () {
                                            $settings.target.find($settings.emailSend).unbind().click(function () {
                                                var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                                var $index = $emails.indexOf($sendEmail);
                                                if ($index > -1) {
                                                    $emails.splice($index, 1);
                                                }
                                                $(this).parents('.item:first').remove();
                                                $settings.callback($sendEmail);
                                            });
                                            $settings.target.find($settings.removeEle).unbind().click(function () {
                                                var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                                var $index = $emails.indexOf($sendEmail);
                                                if ($index > -1) {
                                                    $emails.splice($index, 1);
                                                }
                                                $(this).parents('.item:first').remove();
                                            });
                                        });
                                    }
                                });
                            } else {
                                $that.css('border', '1px solid red');
                                if($that.next().hasClass('error')){
                                    $that.next().remove();
                                }
                                if(!$emailRegex.test($emailInputVal)){
                                    $that.after('<div class="w-100 error">This is not a valid email format. Please edit the address and try again.</div>')
                                }
                                if($emails.indexOf($emailInputVal) != -1){
                                    $that.after('<div class="w-100 error">This email has been added. Please try with other.</div>')
                                }
                            }
                        }
                    }).keyup(function ($e) {
                    if ($e.keyCode === 32 || $e.keyCode === 188) {
                        if ($that.val() == ',' || $that.val() == ';' || $that.val() == ' ') {
                            $that.val('');
                        }
                    }
                    if ($that.val() != '' && !$emailRegex.test($that.val())) {
                        var $emailInputVal = $.trim($that.val());
                        var $acceptedEmails = [];
                        if($emailInputVal.indexOf(";") != -1) {
                            $that.css('border', '');
                            $that.val('');
                            var $newEmailList = $emailInputVal;
                            $newEmailList = $newEmailList.split($splitRegex);
                            for (var $i in $newEmailList) {
                                $emailInputVal = $newEmailList[$i];
                                if ($emailRegex.test($emailInputVal) && $emails.indexOf($emailInputVal) == -1) {
                                    $acceptedEmails.push($emailInputVal);
                                } else {
                                    $that.css('border', '1px solid red');
                                    if($that.next().hasClass('error')){
                                        $that.next().remove();
                                    }
                                    if(!$emailRegex.test($emailInputVal) || $emails.indexOf($emailInputVal) != -1){
                                        $that.after('<div class="w-100 error">Some emails are not valid, or already been added. Please check your list and try again.</div>')
                                    }
                                }
                            }
                            $.ajax({
                                method: $settings.ajax.method,
                                url: $settings.ajax.url,
                                data: $.extend({}, {emails: $acceptedEmails}, $settings.ajax.data),
                                dataType: $settings.ajax.dataType,
                                success: function ($data) {
                                    libs.expire($data);
                                    var $newMultiModel = '';
                                    $.each($acceptedEmails, function($i, $v){
                                        var $model = $settings.model;
                                        $model = $model.replace(/@email/g,$v);
                                        $.each($data.data.users, function($userIndex, $userValue){
                                            if($userValue.email == $v){
                                                $model = $model.replace('@link', $data.data.users[0].profile_url);
                                                $model = $model.replace($($model).find('.not_exist:first').html(), '');
                                                return false;
                                            }
                                            $model = $model.replace($($model).find('.exist:first').html(), '');
                                        });
                                        $newMultiModel += $model;
                                        $emails.push($v);
                                    });
                                    $settings.target.append($newMultiModel).ready(function () {
                                        $settings.target.find($settings.emailSend).unbind().click(function () {
                                            var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                            var $index = $emails.indexOf($sendEmail);
                                            if ($index > -1) {
                                                $emails.splice($index, 1);
                                            }
                                            $(this).parents('.item:first').remove();
                                            $settings.callback($sendEmail);
                                        });
                                        $settings.target.find($settings.removeEle).unbind().click(function () {
                                            var $sendEmail = $.trim($(this).parents('.item:first').data('email'));
                                            var $index = $emails.indexOf($sendEmail);
                                            if ($index > -1) {
                                                $emails.splice($index, 1);
                                            }
                                            $(this).parents('.item:first').remove();
                                        });
                                    });
                                }
                            });
                        }
                    }
                });
            }),
            'emails':$emails
        }
    };
})(jQuery);
